import { defineMessages } from '../../i18n/messages';

export const SecurityMessages = defineMessages({
  PAGE_TITLE: {
    id: 'security.page_title',
    text: 'Security',
    description: 'Page title for the security page',
  },
  PAGE_SUBTITLE: {
    id: 'security.page_subtitle',
    text: 'How we keep your data safe.',
    description: 'Subtitle shown below the page title on the security page',
  },
  INFRASTRUCTURE_TITLE: {
    id: 'security.infrastructure_title',
    text: 'Infrastructure',
    description: 'Section header on the security page for hosting infrastructure details',
  },
  INFRA_ITEM_1: {
    id: 'security.infra_item_1',
    text: 'Hosted entirely on AWS (us-east-1) using managed, SOC 2 compliant services',
    description: 'List item under Infrastructure section. us-east-1 is an AWS region. SOC 2 is a security compliance standard',
  },
  INFRA_ITEM_2: {
    id: 'security.infra_item_2',
    text: 'All data encrypted at rest (AES-256) and in transit (TLS 1.2+)',
    description: 'List item under Infrastructure section. AES-256 and TLS 1.2+ are encryption standards',
  },
  INFRA_ITEM_3: {
    id: 'security.infra_item_3',
    text: 'Serverless architecture (Lambda, DynamoDB). No long-running servers to patch',
    description: 'List item under Infrastructure section. Lambda and DynamoDB are AWS serverless services',
  },
  INFRA_ITEM_4: {
    id: 'security.infra_item_4',
    text: 'CloudFront CDN with HTTPS-only access',
    description: 'List item under Infrastructure section. CloudFront is an AWS content delivery network',
  },
  AUTHENTICATION_TITLE: {
    id: 'security.authentication_title',
    text: 'Authentication',
    description: 'Section header on the security page for login and access methods',
  },
  AUTH_ITEM_1: {
    id: 'security.auth_item_1',
    text: 'User authentication via AWS Cognito (email + Google OAuth)',
    description: 'List item under Authentication section. AWS Cognito is an identity service, OAuth is a login protocol',
  },
  AUTH_ITEM_2: {
    id: 'security.auth_item_2',
    text: 'API key authentication for CLI and programmatic access',
    description: 'List item under Authentication section. CLI is the command-line interface tool',
  },
  AUTH_ITEM_3: {
    id: 'security.auth_item_3',
    text: 'API keys are hashed before storage. Plaintext is shown only once at creation',
    description: 'List item under Authentication section. Hashing is a one-way security transformation',
  },
  DATA_HANDLING_TITLE: {
    id: 'security.data_handling_title',
    text: 'Data Handling',
    description: 'Section header on the security page for data processing and storage details',
  },
  DATA_ITEM_1: {
    id: 'security.data_item_1',
    text: 'Your content is processed by Amazon Bedrock for translation and is not used to train AI models',
    description: 'List item under Data Handling section. Amazon Bedrock is an AWS AI service',
  },
  DATA_ITEM_2: {
    id: 'security.data_item_2',
    text: 'DynamoDB stores all data with per-table encryption',
    description: 'List item under Data Handling section. DynamoDB is an AWS NoSQL database service',
  },
  DATA_ITEM_3: {
    id: 'security.data_item_3',
    text: 'Stripe handles all payment data. We never see or store card numbers',
    description: 'List item under Data Handling section. Stripe is a third-party payment processor',
  },
  DATA_ITEM_4: {
    id: 'security.data_item_4',
    text: 'Webhook payloads are verified using Stripe signature validation',
    description: 'List item under Data Handling section. Webhooks are automated HTTP callbacks from Stripe',
  },
  ACCESS_CONTROL_TITLE: {
    id: 'security.access_control_title',
    text: 'Access Control',
    description: 'Section header on the security page for authorization and permissions',
  },
  ACCESS_ITEM_1: {
    id: 'security.access_item_1',
    text: 'Project-level authorization. Users can only access projects they\'re invited to',
    description: 'List item under Access Control section. A project is a project/organization unit in Localingos',
  },
  ACCESS_ITEM_2: {
    id: 'security.access_item_2',
    text: 'Admin/member role separation for team management',
    description: 'List item under Access Control section describing role-based permissions',
  },
  ACCESS_ITEM_3: {
    id: 'security.access_item_3',
    text: 'Gamma environment restricted to admin group only',
    description: 'List item under Access Control section. Gamma is a pre-production testing environment',
  },
  REPORTING_TITLE: {
    id: 'security.reporting_title',
    text: 'Reporting Vulnerabilities',
    description: 'Section header on the security page for vulnerability disclosure',
  },
  REPORTING_DESC: {
    id: 'security.reporting_desc',
    text: 'If you discover a security issue, please email <a href="mailto:security@localingos.com">security@localingos.com</a>. We take all reports seriously and will respond within 48 hours.',
    description: 'Body text under Reporting Vulnerabilities section. Contains HTML mailto link',
  },
});
